import React, { useState } from "react";
import "../styles/Calendario.css";
import axios from "axios";
import VistaSemanal from "../components/calendario/VistaSemanal";
import VistaDiaria from "../components/calendario/VistaDiaria";
import ModalNuevaCita from "../components/calendario/ModalNuevaCita";
import ModalRecordatorios from "../components/calendario/ModalRecordatorios";

import {
  formatFechaLarga,
  formatSemana,
  getMonday
} from "../utils/fechas";

export default function Calendario() {

  /* ===== Estado global ===== */
  const [vista, setVista] = useState("semana"); // "dia" | "semana"
  const [fecha, setFecha] = useState(new Date());
  const [clinica, setClinica] = useState("ALL");
  const [profesional, setProfesional] = useState("ALL");
  const [mostrarModal, setMostrarModal] = useState(false);
  const [citaSeleccionada, setCitaSeleccionada] = useState(null);
  const [refrescar, setRefrescar] = useState(0);
  const [mostrarRecalls, setMostrarRecalls] = useState(false);

  /* ===== Título de fecha ===== */
  const tituloFecha =
    vista === "dia"
      ? formatFechaLarga(fecha)
      : formatSemana(getMonday(fecha));

  /* ===== Navegación de fechas ===== */
  const moverFecha = (delta) => {
    setFecha(prev => {
      const d = new Date(prev);
      d.setDate(d.getDate() + delta);
      return d;
    });
  };

  return (
    <>
      <div className="calendario-page">

        {/* ================= Toolbar ================= */}
        <div className="calendario-toolbar">

          {/* Izquierda */}
          <div className="toolbar-left">
            <select
              value={clinica}
              onChange={e => setClinica(e.target.value)}
            >
              <option value="ALL">Todas</option>
              <option value="ELIPA">ELIPA</option>
              <option value="VEN">VEN</option>
            </select>
            <select
              value={profesional}
              onChange={e => setProfesional(e.target.value)}
            >
              <option value="ALL">Todos</option>
              <option value="MARIA">MARIA</option>
              <option value="LUCIA">LUCIA</option>
              <option value="LIS">LIS ODONTO</option>
              <option value="LUIS">LUIS</option>
              <option value="PAOLA">PAOLA</option>
              <option value="MARAY">MARAY</option>
              <option value="DANIELA">DANIELA</option>
            </select>

            <button
              className={vista === "dia" ? "activo" : ""}
              onClick={() => setVista("dia")}
            >
              Diaria
            </button>

            <button
              className={vista === "semana" ? "activo" : ""}
              onClick={() => setVista("semana")}
            >
              Semanal
            </button>
          </div>
          
          {/* Centro */}
          <div className="toolbar-center">
            <button
              onClick={() =>
                moverFecha(vista === "dia" ? -1 : -7)
              }
            >
              {"<"}
            </button>

            <strong>{tituloFecha}</strong>

            <button
              onClick={() =>
                moverFecha(vista === "dia" ? 1 : 7)
              }
            >
              {">"}
            </button>
          </div>

          {/* Derecha */}
          <div className="toolbar-right">
            <button
                className="btn-secondary"
                onClick={() => setMostrarRecalls(true)}
              >
                🔔 Recordatorios
            </button>
            <button
              className="btn-primary"
              onClick={() => {
                setCitaSeleccionada(null);
                setMostrarModal(true);
              }}
            >
              Nueva cita
            </button>
          </div>
        </div>

        {/* ================= Vistas ================= */}
        {vista === "semana" && (
          <VistaSemanal
            fecha={fecha}
            clinica={clinica}
            profesional={profesional}
            refrescar={refrescar}
            onSelectCita={(cita) => {
              setCitaSeleccionada(cita);
              setMostrarModal(true);
            }}
            onNuevaCita={(fecha, hora) => {
              const fechaInicio = new Date(fecha);
              fechaInicio.setHours(hora, 0, 0, 0);

              setCitaSeleccionada({
                fechaInicio,
                duracionMin: 30
              });

              setMostrarModal(true);
            }}
          />
        )}

        {vista === "dia" && (
          <VistaDiaria
            fecha={fecha}
            clinica={clinica}
            profesional={profesional}
            refrescar={refrescar}
            onSelectCita={(cita) => {
              setCitaSeleccionada(cita);
              setMostrarModal(true);
            }}
            onNuevaCita={(fecha, hora) => {
              const fechaInicio = new Date(fecha);
              fechaInicio.setHours(hora, 0, 0, 0);

              setCitaSeleccionada({
                fechaInicio,
                duracionMin: 30
              });

              setMostrarModal(true);
            }}
          />
        )}
      </div>

      {/* ================= Modal ================= */}
      {mostrarModal && (
        <ModalNuevaCita
          clinica={clinica}
          profesional={profesional}
          cita={citaSeleccionada}   // null = nueva | con datos = editar
          onClose={() => {
            setMostrarModal(false);
            setCitaSeleccionada(null);
          }}
          onCitaCreada={() => setRefrescar(r => r + 1)}
        />
      )}
      {mostrarRecalls && (
        <ModalRecordatorios
          clinica={clinica}
          onClose={() => setMostrarRecalls(false)}
        />
      )}
    </>
  );
}
